const escapeSelector = str => {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(str);
  }
  return String(str).replace(/["\\]/g, '\\$&');
};

const preselectVariantFromURL = ({
  variantsData,
  optionNames,
  form,
  selectedOptions,
  sellingPlanIdInput,
  updateVariantDetails
}) => {
  const url = new URL(window.location.href);
  const variantIdFromURL = url.searchParams.get('variant');
  if (!variantIdFromURL) return;

  const variant = variantsData.find(v => String(v.id) === variantIdFromURL);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    if (value == null) return;
    selectedOptions[name] = value;

    const en = escapeSelector(name);
    const ev = escapeSelector(value);
    const radio = form.querySelector(`input[type="radio"][name="${en}"][value="${ev}"]`);
    if (radio) {
      radio.checked = true;
    } else {
      const select = form.querySelector(`select[name="${en}"]`);
      if (select) {
        select.value = value;
      }
    }
  });

  const variantStock = String(variant.inventory_quantity ?? '');
  updateVariantDetails(variantStock);

  if (sellingPlanIdInput && url.searchParams.get('selling_plan')) {
    const sellingPlanFromURL = url.searchParams.get('selling_plan');
    sellingPlanIdInput.value = sellingPlanFromURL;
    const sellingPlanInputRadio = form.querySelector(`[data-selling-plan-radio][value="${sellingPlanFromURL}"]`);
    if (sellingPlanInputRadio) {
      sellingPlanInputRadio.checked = true;
    }
    updateVariantDetails(variantStock);
  }
};

export default preselectVariantFromURL;
